import { toast } from "react-toastify";
import { authUIDs, vendorUUIDs } from "../config/constants";
import { routes } from "../routes";
import { useInternalAuth } from "./useInternalAuth";
import { useTeamConfig } from "./useTeamConfig";
import { useTicketmaster } from "./useTicketmaster";
import { useTicketsdotcom } from "./useTicketsdotcom";

export function useGenericOAuth() {
  const { handleConnectTm } = useTicketmaster();
  const { handleInternalRedirect } = useInternalAuth();
  const { handleLoginOkta } = useTicketsdotcom();
  const { platform, shouldUseInternalLogin } = useTeamConfig();

  const connectOAuth = async (state: any) => {
    let error = null;
    let success = false;
    try {
      // internal login
      if (shouldUseInternalLogin) {
        const callback = window.btoa(JSON.stringify(state));
        await handleInternalRedirect(routes.auth, callback, authUIDs.login);
      }
      // ticketmaster
      if (platform === vendorUUIDs.ticketmaster) handleConnectTm(state);

      // ticketsdotcom
      if (platform === vendorUUIDs.tickesdotcom) await handleLoginOkta(state);
      success = true;
    } catch (error) {
      error = error;
    } finally {
      return { success, error };
    }
  };

  return { connectOAuth };
}
